// @flow
import * as React from "react"
import moment from "moment"
import "@reach/dialog/styles.css"
import { css } from "../../node_modules/emotion"
import type { tCrmEvent } from "../types"
import { setHtml } from "../utils"
import { ImageFit } from "./ImageFit"
import { color, mq } from "../styles/variables"
import { ArrowRight } from "./Icons/ArrowRight"

const dateTimeFormat = "MMMM, D YYYY h:mmA" // https://momentjs.com/docs/#/displaying/a
const dateTimeFormatNoTime = "MMMM, D YYYY" // https://momentjs.com/docs/#/displaying/a

export function EventList(props: { items: Array<tCrmEvent>, style?: {} }) {
  return (
    <div
      style={props.style ? props.style : {}}
      className={css`
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -60px;
        overflow: hidden;

        .item {
          display: flex;
          align-items: flex-start;
          width: 100%;
          margin-bottom: 60px;
          flex-direction: column;

          ${mq.sm(
            css`
              flex-direction: row;
            `
          )};

          ${mq.md(css`
            width: calc(50% - 10px);

            &:nth-of-type(odd) {
              padding-right: 20px;
            }
          `)};

          h3 {
            line-height: 21px;
            font-size: 18px;
            color: ${color.rgb.purple[1]};
            font-weight: 600;
            margin-bottom: 5px;
          }

          h4 {
            line-height: 21px;
            font-size: 14px;
            display: flex;
            align-items: center;
          }
        }
      `}
    >
      {props.items.map((event) => (
        <div key={event.id} className="item">
          {event.imgUrl && (
            <div>
              <ImageFit
                src={event.imgUrl}
                className={css`
                  width: 150px;
                  height: 150px;
                  margin-right: 20px;
                `}
              />
            </div>
          )}
          <div>
            <h4 className="h5">
              {moment(event.start).format(
                event.startTime ? dateTimeFormat : dateTimeFormatNoTime
              )}
            </h4>
            <h3>
              <a
                href={`https://secure.spiritualliving.org/np/clients/spiritualliving/event.jsp?event=${
                  event.id
                }`}
              >
                {event.name}
              </a>
            </h3>
            <div
              className={css`
                font-weight: bold;
              `}
            >
              {event.summary && event.summary}
            </div>
            <div
              className={css`
                line-height: normal;
                font-size: 14px;
                margin-bottom: 10px;
              `}
            >
              <EventTopic event={event} />
            </div>
            <a
              className={css`
                display: flex;
                align-items: center;
                color: ${color.rgb.purple[1]};
                text-transform: uppercase;
                padding: 0;

                svg {
                  width: 6px;
                  height: auto;
                  padding-left: 5px;

                  path {
                    fill: ${color.rgb.purple[1]};
                  }
                }
              `}
              href={`https://secure.spiritualliving.org/np/clients/spiritualliving/event.jsp?event=${
                event.id
              }`}
            >
              <span>Learn More</span> <ArrowRight />
            </a>
          </div>
        </div>
      ))}
    </div>
  )
}

function EventTopic({ event }: { event: tCrmEvent }) {
  const limit = event.imgUrl ? 75 : 100

  if (event.topic.length > limit) {
    return <p {...setHtml(event.topic.substring(0, limit) + "&hellip;")} />
  } else {
    return <p {...setHtml(event.topic)} />
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/EventList.js